module.exports = __webpack_public_path__ + "img/phone.2da224a.png";